import React, { Dispatch, FC, useMemo } from 'react';
import { HeaderGroup } from 'react-table';

import { getColumnSorting } from 'helpers/getColumnSorting';
import { SortColumnIndicator } from './sort-column-indicator';
import { IColumnSortingInfo, IHeaderGroup } from 'types/table';

import { ColumnHeaderStyled } from 'ui/table.styled';

interface IColumnHeaderProps {
  column: HeaderGroup<Record<string, unknown>>;
  columnsSorting?: IColumnSortingInfo[];
  sortColumnData?: Dispatch<IColumnSortingInfo>;
}

export const ColumnHeader: FC<IColumnHeaderProps> = (props) => {
  const { column, columnsSorting, sortColumnData } = props;

  const { isSortable, sortBy } = useMemo(() => {
    const sortingInfo = columnsSorting?.find((sortingInfo) => sortingInfo.id === column.id);

    return { sortBy: sortingInfo?.sortBy || null, isSortable: !!sortingInfo };
  }, [columnsSorting]);

  const handleSorting = () => {
    if (isSortable && sortColumnData) {
      sortColumnData({ id: column.id, sortBy: getColumnSorting(sortBy) });
    }
  };

  const getHeaderProps = (column: IHeaderGroup) => ({
    ...column.getHeaderProps([{ style: { ...(column.isFlexUnset && { flex: 'unset' }) } }]),
  });

  return (
    <ColumnHeaderStyled {...getHeaderProps(column)} onClick={handleSorting} withAction={isSortable}>
      <span>
        {column.render('Header')}
        {isSortable && <SortColumnIndicator sortBy={sortBy} />}
      </span>
    </ColumnHeaderStyled>
  );
};
